module.exports = __webpack_public_path__ + "img/wechat_icon.235eb252.png";